
import { 
    getData
} from '@/store/config/method'

const initialState = () => ({
    message: null,
    status: 0,
    ekstrakurikuler: [],
})
const state = initialState
 
const getters = {
    getMessage: state => state.message,
    getStatus: state => state.status,
    getEkstrakurikuler: state => state.ekstrakurikuler || []
}

const actions = {
    async getEkstrakurikulerData({
        commit
    }, {edu_level_slot_id, user_id = null}){
        try {
            const url = user_id 
                ? `/management/my-children/${user_id}/ekstrakurikuler`
                : `/management/user-student/ekstrakurikuler`
            const response = await getData('api',url, {params: {edu_level_slot_id}});
            commit('SET_RESPONSE', response.data);
            commit('SET_EKSTRAKURIKULER_DATA', response.data.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    
    resetState({commit}){
        commit('resetState')
    }
}

const mutations = {
    SET_FAILED(state) {
        state.message = 'Jaringan Bermasalah'
        state.status = 0
    },
    SET_FAILED_MESSAGE(state, error) {
        if(error.status == 400){
            state.message = error.data.message
            state.status = error.data.status
        }else{
            state.message = 'Jaringan Bermasalah'
            state.status = 0
        }
    },
    SET_RESPONSE(state, response) {
        state.message = response.message
        state.status = response.status
    },
    SET_DATA(state, response) {
        state.data = response.data
        state.meta = {
            current_page: response.current_page,
            from: response.from,
            last_page: response.last_page,
            per_page: response.per_page,
            to: response.to,
            total: response.total
        }
    },
    SET_LIST(state, value) {
        state.list = value
    },
    SET_REQUEST(state, value){
        state.request = value
    },
    SET_ITEM(state, value){
        state.item = value
    },
    SET_EKSTRAKURIKULER_DATA(state, value){
        state.ekstrakurikuler = value
    },
    resetState (state) {
        const initial = initialState()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}